import React from 'react';
import { Container, Grid, Box, Typography, Button } from '@mui/material';
import { useHistory, useRouteMatch } from 'react-router-dom';
import routes from '../../../routes';
import { useFormStyles } from '../../Auth/authStyles';
import { Colors } from '../../../assets/theme/Colors';
import loginLogo from '../../../assets/svg/new-logo-with-title-white.svg';

const rescueConfirm = () => {
  const authStyles = useFormStyles();
  const history = useHistory();
  const match = useRouteMatch();

  const confirmed = match.path === routes.rescueConfirm;
  const released = match.path === routes.rescueRelease;

  return (
    <Box sx={authStyles.pageBackground}>
      <Container maxWidth="md">
        <Grid container spacing={2} sx={authStyles.pageContainer} data-testid="login-container">
          <Grid
            item
            xs
            sx={{
              padding: '16px 0 !important',
              maxWidth: { xs: '444px', sm: 'none' },
              width: { xs: '100%', lg: '400px' },
            }}
          >
            <Grid item xs sx={[authStyles.logoWrapper, { py: 3 }]}>
              <Box component="img" src={loginLogo} alt="logo" sx={authStyles.logo} />
            </Grid>

            <Grid item xs sx={{ display: 'flex', justifyContent: 'center' }}>
              <Box
                sx={{
                  backgroundColor: Colors.green.light,
                  borderRadius: 1,
                  maxWidth: 'fit-content',
                  padding: { xs: '16px', sm: '16px 32px' },
                }}
              >
                {confirmed && (
                  <Typography Typography sx={{ color: Colors.white, fontWeight: 500 }} variant="body1">
                    Thank you for confirming your rescue!
                  </Typography>
                )}
                {released && (
                  <Typography sx={{ color: Colors.white, fontWeight: 500 }} variant="body1">
                    Thank you for letting us know you won’t be able to make it! Your site director will attempt to reassign this rescue
                  </Typography>
                )}
                <Box sx={{ paddingTop: 2, textAlign: 'right' }}>
                  <Button
                    sx={{ textTransform: 'none' }}
                    variant="contained"
                    size="small"
                    onClick={() => history.push(routes.index)}
                  >
                    Continue to Food Rescue US
                  </Button>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default rescueConfirm;
